import React, { FC, PropsWithChildren, ReactElement } from 'react';
import { View } from 'react-native';
import { scale as initialScale } from '@components/frame';
import { INFO_SCREEN_LIST_WIDTH } from '@v2/pages/common/constants/base.constants';
import { ScaleFunction } from '@components/operatorPanel/interfaces';

interface DetailsPageLayoutWrapperProps extends PropsWithChildren {
  ListComponent: ReactElement;
  scale?: ScaleFunction;
}

const DetailsPageLayoutWrapper: FC<DetailsPageLayoutWrapperProps> = ({ ListComponent, children, scale = initialScale }) => {
  return (
    <View style={{ flexDirection: 'row', flex: 1 }}>
      <View style={{ width: scale(INFO_SCREEN_LIST_WIDTH) }}>{ListComponent}</View>
      <View style={{ flex: 1 }}>{children}</View>
    </View>
  );
};

export { DetailsPageLayoutWrapper };
